import { requests } from "../../../../api/agent"

export default {
	getKinds      : (params) => requests.getWithParams('/ReConstructionCategory/getKinds', params),
	getList       : (params) => requests.getWithParams('/ReConstructionCategory/getList', params),
	getVolumeList : (params) => requests.getWithParams('/ReConstructionCategory/getVolumeList', params),
	getChilds     : (params) => requests.getWithParams('/ReConstructionCategory/getChilds', params),
	find          : (params) => requests.getWithParams('/ReConstructionCategory/find', params),
	create        : (params) => requests.post('/ReConstructionCategory/create', params),
	delete        : (params) => requests.getWithParams('/ReConstructionCategory/delete', params),
	update        : (params) => requests.post('/ReConstructionCategory/update', params),
	restore       : (params) => requests.getWithParams('/ReConstructionCategory/restore', params),
	getPagedAll   : (params) => requests.getWithParams('/ReConstructionCategory/getPagedAll', params),
	getPagedAudit : (params) => requests.getWithParams('/ReConstructionCategory/getPagedAudit', params)
}